import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { Link, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Pagination } from "@mui/material";
import AuthService from "../../services/auth";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "../../styling/landingtable.css";
import IUPopup from "../updateIncomePop";
import IRPopup from "../removeIncomePop";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { ReactComponent as EditPic } from "../../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../../assets/redfilltrash.svg";
import "./styling/style.css";
import * as Scroll from "react-scroll";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { themModeSelector } from "../../redux/selectors/AuthSelectors";

const fontStyle = "ProximaNova-Bold-03 !important";
const fontSize = "20px !important";

function createData(name, revenue, expenses, source, note, sales) {
  return { name, revenue, expenses, source, note, sales };
}

const rows = [
  createData("Name", "100", "100", "source", "note1", "100"),
  createData("Name 2", "200", "200", "source2", "note2", "200"),
];

const data = [
  {
    name: "Cameron’s Jewelry Shop",
    source: "Etsy",
    revenue: 45,
    note: "",
    expenses: 80,
    sales: 135,
    Profit: 90,
  },
  {
    name: "The Antique Hunter",
    source: "eBay",
    revenue: 60,
    note: "Note",
    expenses: 60,
    sales: 120,
    Profit: 60,
  },
  {
    name: "Cameron’s Closet",
    source: "Poshmark",
    revenue: 40,
    note: "",
    expenses: 30,
    sales: 70,
    Profit: 50,
  },
];

export default function LandingData(props) {
  var scroll = Scroll.animateScroll;
  const history = useHistory();

  const { isDarkMode } = useSelector(themModeSelector);
  const bgColor = isDarkMode ? "#2e2e2e" : "#fbfbfb";
  const textColor = isDarkMode ? "#fbfbfb" : "#2e2e2e";

  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
    action: {
      margin: 5,
      padding: 5,
    },
    tableHead: {
      fontSize: fontSize,
      height: 58,
      backgroundColor: "#f3f0f0",
      color: textColor,
      fontFamily: fontStyle,
    },
    tableDataExpense: {
      color: "#000000",
      backgroundColor: bgColor,
    },
    tableDataRevenue: {
      color: "#000000",
      backgroundColor: bgColor,
    },
    tableDataName: {
      fontWeight: 700,
      backgroundColor: bgColor,
    },
    tableDataNote: {
      backgroundColor: bgColor,
      color: "#A3A3A3",
    },
    tableProfitData: {
      backgroundColor: bgColor,
      color: "green",
    },
    tableDataAction: {
      backgroundColor: bgColor,
    },
  });

  const classes = useStyles();

  const [page, setPage] = useState(1);
  const rowsPerPage = 20;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const overlayref = useRef<HTMLParagraphElement>(null);

  const [show, setShow] = useState(false);
  useEffect(() => {
    if (props.step) {
      setShow(true);
    }
  }, [props.step]);
  //const [user, userState] = useState('');

  function componentMounted() {
    const currUser = AuthService.getCurrentUser();
    if (!currUser) {
      history.push("/auth/login");
    }
    //this.setState({currUser:currUser, userReady:true})
  }
  componentMounted();
  const showstep2 = () => {
    setShow(false);
  };

  const popover = (
    <Popover id="popover-basic6" className="all-popover">
      <Popover.Content className="popover-content">
      Click here to learn about other features.
      </Popover.Content>
    </Popover>
  );

  const scrollTop = () => {
    scroll.scrollToTop();
  };

  return (
    <>
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            <TableCell className={classes.tableHead}>Name</TableCell>
            {/*
            <TableCell align="right" className={classes.tableHead}>Source</TableCell>
            */}
            <TableCell align="left" className={classes.tableHead}>
              Profit
            </TableCell>
            <TableCell align="left" className={classes.tableHead}>
              Revenue
            </TableCell>
            <TableCell align="left" className={classes.tableHead}>
              Expenses
            </TableCell>
            <TableCell align="left" className={classes.tableHead}>
              Notes
            </TableCell>
            <TableCell align="left" className={classes.tableHead}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((nrow, index) => (
            <TableRow key={nrow.name}>
              <TableCell component="th" scope="row">
                {nrow.name == "Cameron’s Jewelry Shop" && show && (
                  <div className="d-flex align-items-center">
                    <Link
                      to={{
                        pathname:
                          "/tutorial_stream/" +
                          nrow.name +
                          `${props.isReplay ? "?replay=true" : ""}`,
                        state: { stream: index ,pathData:nrow.name},
                      }}
                      onClick={scrollTop}
                    >
                      <div
                        className="d-flex align-items-center tablelink"
                        id="click-this"
                      >
                        <div className="upload-image mr-2">
                          <h3 className="text-center">{nrow.name.charAt(0)}</h3>
                        </div>
                        {nrow.name} {">"}
                      </div>
                    </Link>
                    <OverlayTrigger
                      show={show}
                      placement="right"
                      overlay={popover}
                    >
                      <p ref={overlayref}></p>
                    </OverlayTrigger>
                  </div>
                )}
                {nrow.name == "Cameron’s Jewelry Shop" && !show && (
                  <div className="tablelink d-flex align-items-center">
                    <div className="upload-image mr-2">
                      <h3 className="text-center">{nrow.name.charAt(0)}</h3>
                    </div>
                    {nrow.name} {">"}
                  </div>
                )}
                {nrow.name != "Cameron’s Jewelry Shop" && (
                  <div className="tablelink d-flex align-items-center">
                    <div className="upload-image mr-2">
                      <h3 className="text-center">{nrow.name.charAt(0)}</h3>
                    </div>
                    {nrow.name} {">"}
                  </div>
                )}
                <div className="source">{nrow.source}</div>
              </TableCell>
              {/*
              <TableCell align="right" component="th" scope="row">
                {nrow.source}
              </TableCell>
              */}

              <TableCell
                align="left"
                component="th"
                scope="row"
                className={classes.tableProfitData}
              >
                ${nrow.Profit}
              </TableCell>

              <TableCell align="left" component="th" scope="row">
                ${nrow.sales}
              </TableCell>
              <TableCell align="left">${nrow.expenses}</TableCell>
              <TableCell
                align="left"
                component="th"
                scope="row"
                className={classes.tableDataNote}
              >
                {nrow.note}
              </TableCell>

              <TableCell align="left">
                <Popup
                  trigger={
                    <button className="actionbuttonE" disabled>
                      {" "}
                      <EditPic stroke="grey" />{" "}
                    </button>
                  }
                  modal
                  nested
                >
                  {(close) => (
                    <div className="mode">
                      <button className="close" onClick={close}>
                        &times;
                      </button>
                      <div className="header"> Update Income </div>
                      <div className="content">
                        {" "}
                        <IUPopup keydata={nrow} stream={index}></IUPopup>
                        <br />
                      </div>
                    </div>
                  )}
                </Popup>
                <Popup
                  trigger={
                    <button className="actionbutton removebuttonE" disabled>
                      {" "}
                      <RemovePic />{" "}
                    </button>
                  }
                  modal
                  nested
                >
                  {(close) => (
                    <div className="mode">
                      <button className="close" onClick={close}>
                        &times;
                      </button>
                      <div className="header"> Remove Income Source </div>
                      <div className="content">
                        {" "}
                        <IRPopup keydata={nrow} stream={index}></IRPopup>
                        <br />
                      </div>
                    </div>
                  )}
                </Popup>
                {/*
                <input className={classes.action} type="button" value="Edit" disabled></input>
                <input className={classes.action} type="button" value="Remove" disabled></input>
*/}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <div className="d-flex align-items-center justify-content-between mt-5">
    <p className="rows-perpage-text">Showing rows {(page-1)*rowsPerPage+1} to {page*rowsPerPage} of {data.length}</p>
    <Pagination
      count={Math.ceil(data.length / rowsPerPage)}
      variant="outlined"
      shape="rounded"
      page={page}
      onChange={handleChangePage}
    />
  </div>
  </>
  );
}
